const PROGRESSIVE_VALUE = "Progressive";
const FIXED_VALUE = "RevShare";
const ACTIVATION = "activation";

const rewardTypes = [
  { name: "Фиксированная ставка", value: PROGRESSIVE_VALUE },
  { name: "Пассивный доход", value: FIXED_VALUE },
];

const rewardTypesForAdmin = [...rewardTypes, { name: "Активация", value: ACTIVATION }];

export { rewardTypes, rewardTypesForAdmin, PROGRESSIVE_VALUE, FIXED_VALUE, ACTIVATION };
